import { useEffect, useRef } from 'react';
import { Animated } from 'react-native';

export const useAnimation = (initialValue = 0, finalValue = 1, duration = 500, delay = 0) => {
  const animatedValue = useRef(new Animated.Value(initialValue)).current;

  useEffect(() => {
    Animated.timing(animatedValue, {
      toValue: finalValue,
      duration: duration,
      delay: delay,
      useNativeDriver: true,
    }).start();
  }, []);

  return animatedValue;
}; 